// import AuthService from "@/services/AuthService.js";
// import axios from "axios";

export const namespaced = true;

export const state = {
  projects: [
    {
      id: 1,
      created_at: "2019-01-04 19:21:21",
      updated_at: "2019-03-21 15:07:27",
      name: "Test",
      lead_router: "mailroom",
      active: 1,
      domain: "test.com",
      deployment_email: "",
      deployment_slack: "",
      webmaster_email: "test@test.com",
      ua_id: "",
      aw_id: "",
      cloudflare_zone: "",
      app_key: "",
      disavow_active: 1,
    },
    {
      id: 2,
      created_at: "2019-01-04 19:21:21",
      updated_at: "2019-03-13 14:44:26",
      name: "PleuralMesothelioma.com",
      lead_router: "mailroom",
      active: 1,
      domain: "pleuralmesothelioma.com",
      deployment_email: "deploy@pleuralmesothelioma.com",
      deployment_slack: "asbestos-developers",
      webmaster_email: "webmaster@pleuralmesothelioma.com",
      ua_id: "UA-3275196-3",
      aw_id: "AW-978995789",
      cloudflare_zone: "4b419f13339dd025eb379627b41d3ec9",
      app_key: "908379485723435",
      disavow_active: 1,
    },
    {
      id: 3,
      created_at: "2019-01-04 19:21:21",
      updated_at: "2019-03-12 18:14:41",
      name: "MesotheliomaPrognosis.com",
      lead_router: "mailroom",
      active: 1,
      domain: "mesotheliomaprognosis.com",
      deployment_email: "deploy@mesotheliomaprognosis.com",
      deployment_slack: "asbestos-developers",
      webmaster_email: "webmaster@mesotheliomaprognosis.com",
      ua_id: "UA-53095914-1",
      aw_id: "",
      cloudflare_zone: "07b22f5cc710abfa53e8eabeb44ffd79",
      app_key: "673479263476234",
      disavow_active: 1,
    },
    {
      id: 4,
      created_at: "2019-01-04 19:21:22",
      updated_at: "2019-01-08 20:48:25",
      name: "Mesotheliomaveteran.org",
      lead_router: "mailroom",
      active: 0,
      domain: "mesotheliomaveteran.org",
      deployment_email: "",
      deployment_slack: "",
      webmaster_email: "webmaster@mesotheliomaveteran.org",
      ua_id: "UA-109723352-1",
      aw_id: "",
      cloudflare_zone: "",
      app_key: "827403740328404",
      disavow_active: 0,
    },
    {
      id: 5,
      created_at: "2019-01-04 19:21:22",
      updated_at: "2019-03-14 14:17:51",
      name: "Drugwatch.com",
      lead_router: "mailroom",
      active: 1,
      domain: "drugwatch.com",
      deployment_email: "deploy@drugwatch.com",
      deployment_slack: "drugwatch-team",
      webmaster_email: "webmaster@drugwatch.com",
      ua_id: "UA-10629200-1",
      aw_id: "AW-977298675",
      cloudflare_zone: "a9ad2941fefd17874e6e57e698c013fc",
      app_key: "500772372378327",
      disavow_active: 1,
    },
    {
      id: 6,
      created_at: "2019-01-04 19:21:22",
      updated_at: "2019-03-11 15:41:01",
      name: "Annuity.org",
      lead_router: "mailroom",
      active: 1,
      domain: "annuity.org",
      deployment_email: "deploy@annuity.org",
      deployment_slack: "annuity-dev",
      webmaster_email: "webmaster@annuity.org",
      ua_id: "UA-42841390-1",
      aw_id: "AW-973761682",
      cloudflare_zone: "e78ecd257d78acd768ffe543d613dd10",
      app_key: "498567127237893",
      disavow_active: 1,
    },
    {
      id: 7,
      created_at: "2019-01-04 19:21:22",
      updated_at: "2019-03-05 21:10:13",
      name: "StructuredSettlements.com",
      lead_router: "mailroom",
      active: 0,
      domain: "structuredsettlements.com",
      deployment_email: "deploy@structuredsettlements.com",
      deployment_slack: "annuity-dev",
      webmaster_email: "webmaster@structuredsettlements.com",
      ua_id: "UA-124050589-1",
      aw_id: "AW-951449191",
      cloudflare_zone: "dfb38e6ea6fa2646b8b214282f742e31",
      app_key: "127923748723672",
      disavow_active: 0,
    },
    {
      id: 8,
      created_at: "2019-01-04 19:21:22",
      updated_at: "2019-02-28 19:34:40",
      name: "MortgageNote.org",
      lead_router: "mailroom",
      active: 0,
      domain: "mortgagenote.org",
      deployment_email: "deploy@mortgagenote.org",
      deployment_slack: "annuity-dev",
      webmaster_email: "webmaster@mortgagenote.org",
      ua_id: "UA-77394058-1",
      aw_id: "AW-973761682",
      cloudflare_zone: "4bd9f0727ec241d5338b8d7241dd0193",
      app_key: "384327832784236",
      disavow_active: 0,
    },
    {
      id: 9,
      created_at: "2019-01-04 19:21:22",
      updated_at: "2019-03-19 20:23:28",
      name: "Launchthat.com",
      lead_router: "mailroom",
      active: 0,
      domain: "launchthat.com",
      deployment_email: "deploy@launchthat.com",
      deployment_slack: "agency",
      webmaster_email: "webmaster@launchthat.com",
      ua_id: "UA-106878400-1",
      aw_id: "",
      cloudflare_zone: "8284f184db3693cac0b1798bc5aaad19",
      app_key: "837435027434943",
      disavow_active: 0,
    },
    {
      id: 10,
      created_at: "2019-01-04 19:21:22",
      updated_at: "2019-01-08 20:48:40",
      name: "DrugRehab.com",
      lead_router: "mailroom",
      active: 0,
      domain: "drugrehab.com",
      deployment_email: "",
      deployment_slack: "",
      webmaster_email: "webmaster@drugrehab.com",
      ua_id: "UA-64247611-1",
      aw_id: "",
      cloudflare_zone: "",
      app_key: "345245943929742",
      disavow_active: 0,
    },
    {
      id: 11,
      created_at: "2019-01-04 19:21:22",
      updated_at: "2019-01-08 20:48:45",
      name: "Justiceforseniors.org",
      lead_router: "mailroom",
      active: 0,
      domain: "justiceforseniors.org",
      deployment_email: "",
      deployment_slack: "",
      webmaster_email: "webmaster@justiceforseniors.org",
      ua_id: "UA-114140840-1",
      aw_id: "AW-800696446",
      cloudflare_zone: "",
      app_key: "123525765234435",
      disavow_active: 0,
    },
    {
      id: 12,
      created_at: "2019-01-04 19:21:22",
      updated_at: "2019-01-08 20:48:51",
      name: "Truckinjurylawsuits.com",
      lead_router: "mailroom",
      active: 0,
      domain: "truckinjurylawsuits.com",
      deployment_email: "",
      deployment_slack: "",
      webmaster_email: "webmaster@truckinjurylawsuits.com",
      ua_id: "UA-120431679-1",
      aw_id: "AW-802260070",
      cloudflare_zone: "",
      app_key: "562368322743023",
      disavow_active: 0,
    },
    {
      id: 13,
      created_at: "2019-01-04 19:21:22",
      updated_at: "2019-03-08 19:51:43",
      name: "Rounduplawsuits.org",
      lead_router: "mailroom",
      active: 0,
      domain: "rounduplawsuits.org",
      deployment_email: "",
      deployment_slack: "",
      webmaster_email: "webmaster@rounduplawsuits.org",
      ua_id: "UA-124050589-1",
      aw_id: "AW-792814878",
      cloudflare_zone: "",
      app_key: "126734983294324",
      disavow_active: 0,
    },
    {
      id: 14,
      created_at: "2019-01-04 19:21:22",
      updated_at: "2019-02-07 19:59:27",
      name: "Asbestoslungcancer.org",
      lead_router: "mailroom",
      active: 0,
      domain: "asbestoslungcancer.org",
      deployment_email: "",
      deployment_slack: "",
      webmaster_email: "webmaster@asbestoslungcancer.org",
      ua_id: "UA-129829704-1",
      aw_id: "AW-776337726",
      cloudflare_zone: "c1548efc6ba18187152a250f740a47ac",
      app_key: "749573729174759",
      disavow_active: 0,
    },
    {
      id: 15,
      created_at: "2019-01-04 19:21:22",
      updated_at: "2019-01-08 20:49:07",
      name: "RecallCenter.com",
      lead_router: "mailroom",
      active: 0,
      domain: "recallcenter.com",
      deployment_email: "",
      deployment_slack: "",
      webmaster_email: "webmaster@recallcenter.com",
      ua_id: "UA-43502530-1",
      aw_id: "",
      cloudflare_zone: "",
      app_key: "345638227590340",
      disavow_active: 0,
    },
    {
      id: 16,
      created_at: "2019-01-04 19:21:22",
      updated_at: "2019-01-08 20:49:11",
      name: "Holisticguide.org",
      lead_router: "mailroom",
      active: 0,
      domain: "holisticguide.org",
      deployment_email: "deploy@holisticguide.org",
      deployment_slack: "taskforce-newsites",
      webmaster_email: "webmaster@holisticguide.org",
      ua_id: "UA-128976095-1",
      aw_id: "",
      cloudflare_zone: "5596a60c5dedfec44affd799bcc50536",
      app_key: "435672387234982",
      disavow_active: 0,
    },
    {
      id: 17,
      created_at: "2019-01-04 19:21:22",
      updated_at: "2019-01-08 20:49:14",
      name: "Mycollegedegree.org",
      lead_router: "mailroom",
      active: 0,
      domain: "mycollegedegree.org",
      deployment_email: "deploy@mycollegedegree.org",
      deployment_slack: "taskforce-newsites",
      webmaster_email: "webmaster@mycollegedegree.org",
      ua_id: "UA-128981381-1",
      aw_id: "",
      cloudflare_zone: "7c9fac1714680b1d8c78846a4411fd1d",
      app_key: "346246226542462",
      disavow_active: 0,
    },
    {
      id: 18,
      created_at: "2019-01-04 19:21:22",
      updated_at: "2019-01-08 20:49:17",
      name: "Presettlementfund.com",
      lead_router: "mailroom",
      active: 0,
      domain: "presettlementfund.com",
      deployment_email: "deploy@presettlementfund.com",
      deployment_slack: "taskforce-newsites",
      webmaster_email: "webmaster@presettlementfund.com",
      ua_id: "UA-128972463-1",
      aw_id: "",
      cloudflare_zone: "a6bd129b330710322e16e11e57658b7e",
      app_key: "768465456456546",
      disavow_active: 0,
    },
    {
      id: 19,
      created_at: "2019-01-04 19:21:22",
      updated_at: "2019-01-08 20:49:24",
      name: "Counselcenter.org",
      lead_router: "mailroom",
      active: 0,
      domain: "counselcenter.org",
      deployment_email: "deploy@counselcenter.org",
      deployment_slack: "taskforce-newsites",
      webmaster_email: "webmaster@counselcenter.org",
      ua_id: "UA-128956719-1",
      aw_id: "",
      cloudflare_zone: "1f9c672c0607d1858729181315c803d5",
      app_key: "674754373412321",
      disavow_active: 0,
    },
    {
      id: 20,
      created_at: "2019-01-04 19:21:22",
      updated_at: "2019-01-08 20:49:34",
      name: "Mesotheliomafund.org",
      lead_router: "mailroom",
      active: 0,
      domain: "mesotheliomafund.org",
      deployment_email: "deploy@mesotheliomafund.org",
      deployment_slack: "taskforce-newsites",
      webmaster_email: "webmaster@mesotheliomafund.org",
      ua_id: "UA-129017679-1",
      aw_id: "",
      cloudflare_zone: "1e4b6d8662d697713294160d9b9eaf17",
      app_key: "923482129323571",
      disavow_active: 0,
    },
    {
      id: 21,
      created_at: "2019-01-04 19:21:22",
      updated_at: "2019-01-08 20:49:43",
      name: "Figuide.org",
      lead_router: "mailroom",
      active: 0,
      domain: "figuide.org",
      deployment_email: "deploy@figuide.org",
      deployment_slack: "taskforce-newsites",
      webmaster_email: "webmaster@figuide.org",
      ua_id: "UA-128994516-1",
      aw_id: "",
      cloudflare_zone: "21527e7f7272afd8becef85e8b1288f1",
      app_key: "101723423872367",
      disavow_active: 0,
    },
    {
      id: 22,
      created_at: "2019-01-04 19:21:22",
      updated_at: "2019-10-01 15:58:52",
      name: "Consumernotice.org",
      lead_router: "mailroom",
      active: 1,
      domain: "consumernotice.org",
      deployment_email: "deploy@consumernotice.org",
      deployment_slack: "agency",
      webmaster_email: "webmaster@consumernotice.org",
      ua_id: "UA-130788211-1",
      aw_id: "",
      cloudflare_zone: "437b14935e3daf4f665f1b5cb272be9e",
      app_key: "567569823897345",
      disavow_active: 0,
    },
    {
      id: 23,
      created_at: "2019-01-04 19:21:21",
      updated_at: "2019-03-18 17:11:24",
      name: "Asbestos.com",
      lead_router: "mailroom",
      active: 1,
      domain: "asbestos.com",
      deployment_email: "deploy@asbestos.com",
      deployment_slack: "asbestos-developers",
      webmaster_email: "webmaster@asbestos.com",
      ua_id: "UA-3275196-1",
      aw_id: "AW-1041856261",
      cloudflare_zone: "0d643c312297a439922c52eba66769e8",
      app_key: "274572392373246",
      disavow_active: 1,
    },
    {
      id: 25,
      created_at: "2019-01-09 17:16:17",
      updated_at: "2019-01-09 17:18:19",
      name: "Weitzlux.com",
      lead_router: "mailroom",
      active: 0,
      domain: "weitzlux.com",
      deployment_email: "",
      deployment_slack: "",
      webmaster_email: "",
      ua_id: "UA-4194514-1",
      aw_id: "",
      cloudflare_zone: "",
      app_key: "634862254554419",
      disavow_active: 0,
    },
    {
      id: 27,
      created_at: "2019-02-26 16:29:32",
      updated_at: "2019-02-26 16:29:32",
      name: "GetPowerToday.com",
      lead_router: "mailroom",
      active: 0,
      domain: "getpowertoday.com",
      deployment_email: "",
      deployment_slack: "",
      webmaster_email: "webmaster@getpowertoday.com",
      ua_id: "UA-134386605-1",
      aw_id: "",
      cloudflare_zone: "",
      app_key: "940063876159787",
      disavow_active: 0,
    },
    {
      id: 28,
      created_at: "2019-03-12 17:21:41",
      updated_at: "2019-03-12 17:21:41",
      name: "Hula.com",
      lead_router: "mailroom",
      active: 0,
      domain: "hula.com",
      deployment_email: "deploy@hula.com",
      deployment_slack: "",
      webmaster_email: "webmaster@hula.com",
      ua_id: "",
      aw_id: "",
      cloudflare_zone: "",
      app_key: "612219667404261",
      disavow_active: 0,
    },
    {
      id: 29,
      created_at: "2019-07-25 14:52:13",
      updated_at: "2019-07-25 14:52:13",
      name: "Vetoutreach.com",
      lead_router: "mailroom",
      active: 0,
      domain: "vetoutreach.com",
      deployment_email: "",
      deployment_slack: "",
      webmaster_email: "webmaster@vetoutreach.com",
      ua_id: "",
      aw_id: "",
      cloudflare_zone: "425c75b9ee7cf9c782c667ee4912dac4",
      app_key: "974233637491351",
      disavow_active: 0,
    },
    {
      id: 30,
      created_at: "2020-04-02 14:57:22",
      updated_at: "2020-04-02 14:57:40",
      name: "Retireguide.com",
      lead_router: "mailroom",
      active: 1,
      domain: "retireguide.com",
      deployment_email: "deploy@retireguide.com",
      deployment_slack: "",
      webmaster_email: "webmaster@retireguide.com",
      ua_id: "",
      aw_id: "",
      cloudflare_zone: "",
      app_key: "510769818950388",
      disavow_active: 1,
    },
  ],
};

export const mutations = {};

export const actions = {};

export const getters = {
  activeProjects: (state, getters, rootState, rootGetters) => {
    let userProjects = JSON.parse(rootGetters["user/userProjects"]);
    /* let activeProjects = userProjects.map(project_id => {
      return state.projects.find(project => project.id === project_id);
    });*/
    console.log(userProjects);

    let activeProjectsArray = [];

    let i;
    for (i = 0; i < state.projects.length; i++) {
      if (state.projects[i].active === 1) {
        activeProjectsArray.push(state.projects[i]);
      }
    }
 
    return activeProjectsArray;

    // return activeProjects;
  },
};
